/**
 * Modal Registry - Maps modal types to their components
 * This separates the component loading from the content configuration
 */

export const MODAL_REGISTRY = {
    'auth-prompt': {
        component: () => import('../components/modals/auth-prompt-modal.vue'),
    },
    'premium-upsell': {
        component: () => import('../components/modals/premium-upsell-modal.vue'),
    },
    'error': {
        component: () => import('../components/modals/error-modal.vue'),
    },
    'confirmation': {
        component: () => import('../components/modals/confirmation-modal.vue'),
    },
    'in-app-browser': {
        component: () => import('../components/modals/in-app-browser-modal.vue'),
    },
    'simple-message': {
        component: () => import('../components/modals/simple-message-modal.vue'),
    },
}

/**
 * Get modal component by type
 * @param {string} type - The modal type
 * @returns {Function|null} The component loader function or null if not found
 */
export function getModalComponent(type) {
    const modal = MODAL_REGISTRY[type]
    if (!modal) {
        console.error(`Modal type "${type}" not registered`)
        return null
    }
    return modal.component
}